module.exports = __webpack_public_path__ + "img/news-default.7b20cd8a.jpg";